import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-02/lesson-09/task-03";

const task: Slide = {
  title: "Connect each of these tonality algorithms to their drawback(s)",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
